<div class="fixed inset-0 flex flex-col items-center justify-center bg-surface text-on-surface">
  <div class="flex items-center gap-3 mb-3">
    <span class="material-symbols-outlined text-primary splash-pulse" style="font-size: 56px;">webhook</span>
    <h1 class="text-3xl font-medium tracking-wide">hook-index</h1>
  </div>
  <p class="text-sm text-on-surface-variant">Loading workspace…</p>
</div>

<style>
  .splash-pulse {
    animation: splash-pulse 1.4s ease-in-out infinite;
  }
  @keyframes splash-pulse {
    0%, 100% { opacity: 1;   transform: scale(1); }
    50%      { opacity: 0.55; transform: scale(0.92); }
  }
</style>
